import { createContext } from "react";

const shopContext = createContext();


export default shopContext;